import React from "react";

interface ToggleProps {
  checked: boolean;
  onChange: () => void;
  label: string;
}

const ToggleCheckbox: React.FC<ToggleProps> = ({
  checked,
  onChange,
  label,
}) => (
  <label
    style={{
      display: "inline-flex",
      alignItems: "center",
      gap: "0.4rem",
      cursor: "pointer",
      userSelect: "none",
      opacity: checked ? 1 : 0.45,
    }}
  >
    <input
      type="checkbox"
      checked={checked}
      onChange={onChange}
      style={{ cursor: "pointer", width: "1rem", height: "1rem" }}
    />
    {label}
  </label>
);

interface Props {
  showOnlyAttemptedContest: boolean;
  toggleShowOnlyAttemptedContest: () => void;
  hideCompleteContests: boolean;
  toggleHideCompleteContests: () => void;
  showDifficulties: boolean;
  toggleShowDifficulties: () => void;
}

export const Options: React.FC<Props> = (props) => {
  return (
    <div
      className="my-2"
      style={{ display: "flex", gap: "1.5rem", alignItems: "center" }}
    >
      <ToggleCheckbox
        checked={props.showDifficulties}
        onChange={props.toggleShowDifficulties}
        label="Difficulty"
      />
      <ToggleCheckbox
        checked={props.showOnlyAttemptedContest}
        onChange={props.toggleShowOnlyAttemptedContest}
        label="Attempted Only"
      />
      <ToggleCheckbox
        checked={props.hideCompleteContests}
        onChange={props.toggleHideCompleteContests}
        label="Hide Complete"
      />
    </div>
  );
};
